__turbopack_context__.v({
  "supportContent": "support-module-scss-module__xwpwSW__supportContent",
  "supportDescription": "support-module-scss-module__xwpwSW__supportDescription",
  "supportHeading": "support-module-scss-module__xwpwSW__supportHeading",
  "supportPattern": "support-module-scss-module__xwpwSW__supportPattern",
  "supportTitle": "support-module-scss-module__xwpwSW__supportTitle",
});
